import { useEffect, useState } from 'react';
import {useLocation, useHistory} from 'react-router-dom'
import userApi from '../api/userApi';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

const Alert = props => {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}


const ActiveEmail = () => {
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }
    const history = useHistory()
    const query = useQuery()
    const token = query.get('token')
    const [openMessage, setOpenMessage] = useState(false)

    useEffect(() => {
        (async () => {
            try {
                const response = await userApi.activeEmail({token})

                if(response.success) {
                    setOpenMessage(true)
                    history.push('/')
                }
            } catch (error) {
                console.log(error)
            }
        })()

    },[token, history])
    
    const handleCloseMessage = (event, reason) => {
        if (reason === 'clickaway')
            return;
    }

    return (
        <Snackbar 
            open={openMessage} 
            autoHideDuration={4000} 
            onClose={handleCloseMessage}
        >
            <Alert onClose={handleCloseMessage} severity="success">
                Kích hoạt tài khoản thành công
            </Alert>
        </Snackbar>
    )
}

export default ActiveEmail
